import gsap from "gsap";

(function ($) {

    $(document).ready(function () {
        let time = 5000, speed = 1000;
        let images = $(".images-wrap")
        let titleSlider = $(".title-slider")
        let contents = $(".contents-wrap")

        const splitSliderTitle = new Swiper('.title-slider', {
            loop: true,
            slidesPerView: 'auto',
            speed: speed,
            slideToClickedSlide: true,
            autoplay: {
                delay: time,
                disableOnInteraction: false
            },
            breakpoints: {
                1920: {
                    spaceBetween: 200,
                },
                1440: {
                    spaceBetween: 0
                }
            },
            on: {
                click: function (swiper) {
                },
                slideChange: function (swiper) {
                    toggleBG(swiper.realIndex)
                    progressBar(swiper)
                },
            }

        });

        //toggle background image
        function toggleBG(index) {
            images.find(".item.active").removeClass("active")
            images.find(".item").eq(index).addClass("active")

            toggleContent(index)
        }

        //toggle content
        function toggleContent(index) {
            contents.find(".item.active").removeClass("active")
            contents.find(".item").eq(index).addClass("active")
        }

        //handle hover effect
        titleSlider.find(".swiper-slide .title").on({
            mouseenter: function () {
                let index = $(this).data('index')
                let activeSlideIndex = titleSlider.find(".swiper-slide-active .title").data('index')

                if (index !== activeSlideIndex) {
                    titleSlider.find(".swiper-slide-active .title").addClass("-another-slide-hovered")
                    toggleBG(index)
                }

            },
            mouseleave: function () {
                let index = titleSlider.find(".swiper-slide-active .title").data('index')
                titleSlider.find(".swiper-slide .title").removeClass("-another-slide-hovered")
                toggleBG(index)
            }
        })

        //progress bar
        function progressBar(swiper) {
            let currentNum = $(".current-slide-num .num-wrap");
            let nextNum = $(".next-slide-num .num-wrap");
            let progressBar = $(".progress-line .line");

            let slideIndex = swiper.realIndex;
            let lastSlide = swiper.loopedSlides - 1;
            let numHeight = $(".slide-num li").height();

            gsap.to(currentNum, {
                y: (slideIndex) * -numHeight
            })
            gsap.to(nextNum, {
                y: (slideIndex === lastSlide) ? 0 : (slideIndex + 1) * -numHeight
            })
            gsap.fromTo(progressBar, {
                scaleX: 0
            }, {
                scaleX: 100 + '%',
                ease: 'none',
                duration: (time + speed) / 1000
            })
        }

    })

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/section_full_width_slider.js